import lodashGet from 'lodash/get';
import { savePersonalSyncStatus, loadPersonalSyncStatus } from './contact_sync_personal_status';
export class ContactSyncCore {
    constructor(ctx, coordinator) {
        this.syncStatusMap = new Map();
        this.ctx = ctx;
        this.coordinator = coordinator;
    }
    async doSyncAction(options) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { force = false, enablePolling = true } = options;
        if (this.syncStatusMap.get(options._account) === 'ing') {
            console.warn('[contact_sync] sync in progress: ' + window.location.pathname);
            return '正在同步中';
        }
        this.syncStatusMap.set(options._account, 'ing');
        if (force) {
            this.ctx.dataTracker.track('pc_contact_trigger_sync', {
                _account: options._account,
                recordSubAccount: false,
            });
        }
        const sessionTrigger = (_a = options.trigger) !== null && _a !== void 0 ? _a : (force ? 'force' : 'timer');
        const sessionId = (_c = (_b = this.ctx.tracker) === null || _b === void 0 ? void 0 : _b.startSession(sessionTrigger, options._account)) !== null && _c !== void 0 ? _c : '';
        try {
            const personalSyncTask = async () => {
                var _a, _b, _c, _d, _e, _f, _g;
                const corePersonalStartTime = Date.now();
                const prevStatus = await loadPersonalSyncStatus(this.ctx.storeApi);
                await savePersonalSyncStatus(this.ctx.storeApi, { status: 'syncing', lastDexieWriteTime: (_a = prevStatus === null || prevStatus === void 0 ? void 0 : prevStatus.lastDexieWriteTime) !== null && _a !== void 0 ? _a : 0 }, options._account);
                (_b = this.ctx.tracker) === null || _b === void 0 ? void 0 : _b.recordTask(sessionId, { type: 'personal', phase: 'fetch' });
                (_c = this.ctx.tracker) === null || _c === void 0 ? void 0 : _c.recordTask(sessionId, { type: 'personalOrg', phase: 'fetch' });
                try {
                    const res = await Promise.all([
                        this.ctx.contactServer.syncPersonContactList(Object.assign({ force }, this.ctx.contactUtil.getPublicParamFromMultipleOptions(options))),
                        this.ctx.contactServer.syncPersonalOrgList(Object.assign({ force }, this.ctx.contactUtil.getPublicParamFromMultipleOptions(options))),
                    ]);
                    const countMap = Object.fromEntries(res.map(item => [item.from, item.count || 0]));
                    (_d = this.ctx.tracker) === null || _d === void 0 ? void 0 : _d.updateTaskProgress(sessionId, 'personal', { serverContactCount: countMap.personal || 0, phase: 'done' });
                    (_e = this.ctx.tracker) === null || _e === void 0 ? void 0 : _e.updateTaskProgress(sessionId, 'personalOrg', { serverContactCount: countMap.personalOrg || 0, phase: 'done' });
                    this.ctx.dataTracker.track('pc_sync_core_personal_done', Object.assign({ _account: options._account, status: 'success', msg: '', duration: Date.now() - corePersonalStartTime }, (countMap || {})));
                }
                catch (ex) {
                    console.error('[contact_sync] personal sync failed', ex);
                    const errMsg = lodashGet(ex, 'message', `${ex}`);
                    (_f = this.ctx.tracker) === null || _f === void 0 ? void 0 : _f.updateTaskProgress(sessionId, 'personal', { phase: 'error', error: errMsg });
                    (_g = this.ctx.tracker) === null || _g === void 0 ? void 0 : _g.updateTaskProgress(sessionId, 'personalOrg', { phase: 'error', error: errMsg });
                    this.ctx.dataTracker.track('pc_sync_core_personal_done', {
                        _account: options._account,
                        msg: errMsg,
                        duration: Date.now() - corePersonalStartTime,
                        status: 'fail',
                    });
                }
                this.ctx.contactDB.sendContactNotify(Object.assign({ syncStatus: { personal: true, personalOrg: true } }, this.ctx.contactUtil.getPublicParamFromMultipleOptions(options)));
            };
            const enterpriseSyncTask = async () => {
                try {
                    const dexiePromises = await this.coordinator.sync({
                        force,
                        _account: options._account,
                        isMainAccount: options.isMainAccount,
                        sessionId,
                        enablePolling,
                    });
                    this.ctx.contactDB.sendContactNotify(Object.assign({ syncStatus: { enterprise: true, org: true } }, this.ctx.contactUtil.getPublicParamFromMultipleOptions(options)));
                    return dexiePromises;
                }
                catch (ex) {
                    console.error('[contact_sync] enterprise sync failed', ex);
                    return [];
                }
            };
            const personalTask = options.skipPersonalSync ? Promise.resolve() : personalSyncTask();
            const [, dexiePromises] = await Promise.all([personalTask, enterpriseSyncTask()]);
            if (force) {
                this.ctx.contactDB.sendContactNotify({
                    isAll: true,
                    _account: options._account,
                });
            }
            this.ctx.loggerApi.track('contact_sync_suceess', {
                contactSyncTimes: this.ctx.contactDB.contactSyncTimes,
            });
            await Promise.all(dexiePromises !== null && dexiePromises !== void 0 ? dexiePromises : []);
        }
        catch (ex) {
            console.error('[contact_sync] doSyncAction failed', ex);
            (_d = this.ctx.tracker) === null || _d === void 0 ? void 0 : _d.endSession(sessionId, 'error');
        }
        if (((_f = (_e = this.ctx.tracker) === null || _e === void 0 ? void 0 : _e.getCurrentSession()) === null || _f === void 0 ? void 0 : _f.id) === sessionId) {
            (_g = this.ctx.tracker) === null || _g === void 0 ? void 0 : _g.endSession(sessionId, 'done');
        }
        this.syncStatusMap.set(options._account, 'init');
        return true;
    }
}
